import { FC } from "react";

const ManageOrganizationsIcon: FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      style={{
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        fill: "currentColor",
        flexShrink: 0,
        transition: "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        fontSize: "1.5rem",
      }}
    >
      <path d="M2 20V4h10v4h8v5.1a5.024 5.024 0 00-2-.92V10h-6v10H2zm2-2h2v-2H4v2zm0-4h2v-2H4v2zm0-4h2V8H4v2zm4 8h2v-2H8v2zm0-4h2v-2H8v2zm0-4h2V8H8v2zm4-2v2h2v-2h-2z" />
      <path d="M18.1 22.2l-.4-1.7c-.2-.1-.4-.1-.5-.2l-1.5.6-1-1.7 1.2-1.1c0-.1-.1-.3-.1-.5s0-.3.1-.5l-1.2-1.1 1-1.7 1.5.6c.2-.1.4-.2.5-.2l.4-1.7h2l.4 1.7c.2.1.4.1.5.2l1.5-.6 1 1.7-1.2 1.1c0 .1.1.3.1.5s0 .3-.1.5l1.2 1.1-1 1.7-1.5-.6c-.2.1-.4.2-.5.2l-.4 1.7h-2zm1-2.7c.6 0 1-.2 1.4-.6.4-.4.6-.8.6-1.4 0-.6-.2-1-.6-1.4-.4-.4-.8-.6-1.4-.6-.6 0-1 .2-1.4.6-.4.4-.6.8-.6 1.4 0 .6.2 1 .6 1.4.4.4.8.6 1.4.6z" />
    </svg>
  );
};

export default ManageOrganizationsIcon;
